import i18n from './i18n';

export const FlashDefinition = {
  askAIRequestLimit: {
    context: [{ detail: i18n.askAIRequestLimit }],
    status: 'error',
  },
};
